import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import landingPageReducer from '../pages/landing_page/LandingPageSlice';
import importPageReducer from '../pages/administrator/AdministratorPageSlice';
import loginPageReducer from '../pages/login_page/LoginPageSlice';
import unsubscribePageReducer from '../pages/unsubscribe_page/UnsubscribePageSlice';
import reportingPageReducer from '../pages/reporting/ReportingSlice'
import administratorOptionsPageReducer from '../pages/administrator_options/AdministratorOptionsPageSlice'
import keyTransferPageReducer from '../pages/key_transfer/KeyTransferPageSlice'

export const store = configureStore({
  reducer: {
    landingPage: landingPageReducer,
    importPage: importPageReducer,
    loginPage: loginPageReducer,
    unsubscribePage: unsubscribePageReducer,
    reportingPage: reportingPageReducer,
    administratorOptionsPage: administratorOptionsPageReducer,
    keyTransferPage: keyTransferPageReducer,
  }, middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
